"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var GroupOfSitesIntersection_1 = require("../model/GroupOfSitesIntersection");

var GroupOfSitesIntersectionConverter_1 = require("./GroupOfSitesIntersectionConverter");
/**
 * @author Jan Gregor
 */


var GroupOfSitesIntersectionConverterImpl =
/*#__PURE__*/
function (_GroupOfSitesIntersec) {
  _inherits(GroupOfSitesIntersectionConverterImpl, _GroupOfSitesIntersec);

  function GroupOfSitesIntersectionConverterImpl() {
    _classCallCheck(this, GroupOfSitesIntersectionConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesIntersectionConverterImpl).apply(this, arguments));
  }

  _createClass(GroupOfSitesIntersectionConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new GroupOfSitesIntersection_1.GroupOfSitesIntersection(GroupOfSitesIntersection_1.GroupOfSitesIntersection.schema.id.valueOf(conversions.documentToClassId(source)), conversions.asObjectList(source, 'gosIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'commonBinding', this.deserializeCommonBinding(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        gosIds: conversions.asObjectArray(source, 'gosIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        commonBinding: conversions.asObjectArray(source, 'commonBinding', this.serializeCommonBinding(conversions))
      });
      return result;
    }
  }, {
    key: "deserializeCommonBinding",
    value: function deserializeCommonBinding(conversions) {
      return function (document) {
        if (!document.siteId) {
          throw new DataDictionaryError_1.DataDictionaryError("siteId is missing!");
        }

        if (!document.validFrom) {
          throw new DataDictionaryError_1.DataDictionaryError("validFrom is missing!");
        }

        return {
          siteId: conversions.toClassReferenceId(document.siteId),
          validFrom: conversions.toDate(document.validFrom),
          validTo: conversions.toDate(document.validTo)
        };
      };
    }
  }, {
    key: "serializeCommonBinding",
    value: function serializeCommonBinding(conversions) {
      return function (object) {
        if (typeof object !== 'object' || object === null) {
          return null;
        }

        return {
          siteId: conversions.toDocumentReferenceId(object.siteId),
          validFrom: conversions.fromDate(object.validFrom),
          validTo: conversions.fromDate(object.validTo)
        };
      };
    }
  }]);

  return GroupOfSitesIntersectionConverterImpl;
}(GroupOfSitesIntersectionConverter_1.GroupOfSitesIntersectionConverter);

exports.GroupOfSitesIntersectionConverterImpl = GroupOfSitesIntersectionConverterImpl;